(function () {
  'use strict';
  angular.module('vcdms.vcscan')
    .component('scansorter', {
      restrict: 'E',
      bindings: {
        file: '=',
        fileid: '=',
        saved: '=',
        saving: '=',
        saveerror: '=',
        parentsave: '&',
        parentrendered: '&',
        clientmode: '<?',
        filemode: '@'
      },
      templateUrl: 'vcdms/scan/scansorter-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Rlog', 'pdfDelegate', 'Config', '$scope', '$http', 'LogReminderHelper', '$cookies', 'ClientHelper',
        function ($log, Rlog, pdfDelegate, Config, $scope, $http, LogReminderHelper, $cookies, ClientHelper) {
          let vm = this;
          vm.save = save;
          vm.saveClient = saveClient;
          vm.parentRendered = parentRendered;
          vm.resetViewer = resetViewer;

          vm.getTags = getTags;
          vm.clearPatient = clearPatient;
          vm.clearClient = clearClient;
          vm.saveKeywords = saveKeywords;
          vm.assignCat = assignCat;

          vm.formDisabled = formDisabled;
          vm.formSignoffDisabled = formSignoffDisabled;
          vm.finish = finish;
          vm.finishSignoff = finishSignoff;
          vm.diagClientSave = diagClientSave;

          vm.addLog = addLog;
          vm.addReminder = addReminder;

          // Control PDF Viewer
          vm.nextPage = nextPage;
          vm.previousPage = previousPage;
          vm.rotatePage = rotatePage;
          vm.gotoPage = gotoPage;
          vm.zoomIn = zoomIn;
          vm.zoomOut = zoomOut;

          vm.firstchange = true;


          $scope.$watch(() => vm.file, function (newValue, oldValue, scope) {
            // $log.debug('[DMS][SCAN][ScanSorter] file watch fired old, new: ', oldValue._id, newValue._id, scope);
            // Rlog.debug('dms.scan', 'scansorter', 'watch triggered', {newValue: newValue, oldValue: oldValue});
            if ((angular.isDefined(newValue) && vm.firstchange) || ((angular.isDefined(newValue) && angular.isDefined(oldValue)) && oldValue.fileid !== newValue.fileid)) {
              // $log.debug('[DMS][SCAN][ScanSorter] Is firstchange: ', vm.firstchange);
              vm.firstchange = false;
              // if (angular.isDefined(newValue)) {
              $log.debug('[DMS][SCAN][ScanSorter] file watch fired, fileid changed: ', newValue.fileid, oldValue.fileid);
              vm.resetViewer();

              pdfDelegate.load('/routes/files/filereader/' + newValue.fileid).then(
                function () {
                  $log.debug('[DMS][SCAN][ScanSorter] Scansorter retrieved binaryfile: ', newValue.fileid);
                  Rlog.debug('dms.scan', 'scansorter', 'successfully rendered pdf file', {
                    mode: vm.filemode,
                    fileid: newValue.fileid
                  });
                  delete vm.docloading;
                  vm.docready = true;
                  vm.parentRendered(vm.file, true);
                  vm.maxpc = pdfDelegate.getPageCount();
                  vm.currentpage = pdfDelegate.getCurrentPage();
                }, (err) => {
                  vm.parentRendered(vm.file, false);
                  vm.docready = true;
                  vm.pdferror = true;
                  delete vm.docloading;
                  $log.warning('[DMS][SCAN][ScanSorter] PDF delegate failed: ', err);
                  Rlog.error('dms.scan', 'scansorter', 'failed to rendered pdf file', {});
                }
              );
              // get patient diagnoses

              if (angular.isDefined(vm.file.patientid)) {
                ClientHelper.find(vm.clientmode, vm.file.patientid).$then(function (client) {
                  vm.client = client;
                  if (angular.isUndefined(vm.client.deleteddiagnoses) || !angular.isArray(vm.client.deleteddiagnoses)) {
                    vm.client.deleteddiagnoses = [];
                    vm.client.$save();
                    $log.debug('[DMS][SCAN][ScanSorter] initalised deleteddiagnoses to empty array');
                  }
                });
              }
              // $scope.apply();
            }
          }, true);


          vm.$onInit = function () {
            vm.rotatestate = 0;
            vm.landscape = false;
            $log.debug('[DMS][SCAN][ScanSorter] Scansorter $onInit file: ', vm.file._id, vm.file);

            // retrieve customer document classifications
            Config.$find('dmsgencat').$then((dc) => {
              vm.dmsgencat = dc.dmsgencat;
            });
            Config.$find('dmspatientcat').$then((pc) => {
              vm.dmspatientcat = pc.dmspatientcat;
            });

            // get document pagecount
            vm.maxpc = pdfDelegate.$getByHandle('scans-pdf-container').getPageCount();
          };


          function resetViewer() {
            vm.docloading = true;
            vm.docready = false;
            vm.pdferror = false;
            vm.ready = false;
            while (vm.rotatestate !== 0) {
              vm.rotatePage();
            }
            vm.currentpage = 1;
            vm.maxpc = 1;
          }


          // catch late propagating clientmode changes
          vm.$onChanges = function (changes) {
            // $log.debug('[DMS][SCAN][ScanSorter] Scansorter $onChanges');
            if (!changes.isFirstChange) {
              // $log.debug('[DMS][SCAN][ScanSorter] Scansorter $onChanges not first change: ', changes);
              if (angular.isDefined(changes.clientmode) && angular.isDefined(changes.clientmode.currentValue)) {
                $log.debug('[DMS][SCAN][ScanSorter] $onChanges clientmode changed: ', changes.clientmode.currentValue);

                vm.clientmode = changes.clientmode.currentValue;
                if (vm.clientmode === 'patient') {
                  vm.kunde = 'Patient';
                  vm.kunden = 'Patienten';
                } else {
                  vm.kunde = 'Kunde';
                  vm.kunden = 'Kunden';
                }
              }
            }
          };


          // use aggregate query to obtain a list of distinct tags
          // first match all documents containing a tag that fits the regex
          // then unwind the document per tag to obtain multiple copies
          function getTags(val) {
            // $log.debug('[DMS][SCAN][ScanSorter] getTags query; ', val);
            // let myregex = '^' + val; // when using $regex, do not include '/' for regex delimiter
            let myregex = val; // when using $regex, do not include '/' for regex delimiter
            let match = [
              {$match: {flattags: {$regex: myregex, $options: 'i'}}},
              {$unwind: '$flattags'},
              {$match: {flattags: {$regex: myregex, $options: 'i'}}},
              {$group: {_id: '$flattags', total: {$sum: 1}}}];
            // $log.debug('[DMS][SCAN][ScanSorter] scansorter  Sending tags query');
            return $http.post('/routes/files/aggregate', match).then(function (response) {
              // $log.debug('[DMS][SCAN][ScanSorter] tags received: ', response);
              let tags = new Set();
              if (angular.isDefined(response) && angular.isDefined(response.data) && response.data.length > 0) {
                // create set to group by value
                tags = new Set(response.data.map(function (tag) {
                  return tag._id;
                }));
                // $log.debug('[DMS][SCAN][ScanSorter] tags set from array result: ', tags);
              } else if (angular.isDefined(response) && angular.isDefined(response.data) && angular.isDefined(response.data._id)) {
                tags = new Set([response.data._id]);
                // $log.debug('[DMS][SCAN][ScanSorter] tags set from single result: ', tags);

              }
              // return array because ngTagsLib expects an array not a set
              // $log.debug('[DMS][SCAN][ScanSorter] array for ngTagsLib : ', Array.from(tags));
              return Array.from(tags);
            });
          }


          function saveClient(client, mode) {
            $log.debug('[DMS][SCAN][ScanSorter] saveClient called with: ', client, mode);
            if (mode === 'patient') {
              vm.file.patientid = client._id;
              vm.file.patientfname = client.primarycontact.firstname + ' ' + client.primarycontact.lastname + ', ' + client.svdata.svnr;
            } else {
              vm.file.clientid = client._id;
              vm.file.clientfname = client.primarycontact.firstname + ' ' + client.primarycontact.lastname;
            }

            ClientHelper.find(mode, client._id).$then(function (lclient) {
              vm.client = lclient;
            });

            $log.debug('[DMS][SCAN][ScanSorter] saveClient assigned fname: ', vm.file.patientfname, vm.file.clientfname);

            vm.save(false);
          }

          function diagClientSave() {
            if (vm.client.$hasPendingActions()) {
              vm.client.$cancel();
            }
            vm.client.$save().$then(() => {
            }, (error) => {
              $log.error('[DMS][SCAN][ScanSorter] failed to save client (diagnoses): ', error);
              Rlog.error('vcdms', 'scansorter', 'failed to save client (diagnoses)', {});
              // Rlog.error('vcdms', 'scansorter', 'failed to save client (diagnoses)', {clientid: vm.client._id, mode: vm.clientmode});
            });
          }

          function assignCat(cat) {
            switch (cat) {
              case 'generic':
                if (vm.clientmode === 'patient') {
                  clearPatient();
                } else {
                  clearClient();
                }
                break;
              case 'patient':
                break;
              default:
                break;
            }
            vm.file.doccat = cat;
            vm.save(false);
          }

          function finish() {

            switch (vm.file.doccat) {
              case 'generic':
                vm.file.scanstatus = 'finished';
                break;
              case 'patient':
                vm.file.scanstatus = 'assigned';
                break;
              default:
                break;
            }
            $log.debug('[DMS][SCAN][ScanSorter] vm.finish() assigning called for: ', vm.file._id, vm.file.scanstatus);
            save(true);
          }


          function finishSignoff() {
            $log.debug('[DMS][SCAN][ScanSorter] vm.finishSignoff() called');

            vm.file.scanstatus = 'finished';
            vm.file.signatureuser = $cookies.get('username');
            save(true);
          }


          function saveKeywords() {
            $log.debug('[DMS][SCAN][ScanSorter] save keywords: ', vm.file.keywords);
            let flattags = [];
            if (angular.isArray(vm.file.keywords)) {
              for (let i = 0; i < vm.file.keywords.length; i++) {
                flattags.push(vm.file.keywords[i].text);
              }
              vm.file.flattags = flattags;
              vm.save(false);
            }
          }


          function clearPatient() {
            delete vm.file.patientid;
            delete vm.file.patientfname;
            // delete vm.file.doccat;
            vm.file.scanstatus = 'captured';
            vm.save(false);
          }

          function clearClient() {
            delete vm.file.clientid;
            delete vm.file.clientfname;
            // delete vm.file.doccat;
            vm.file.scanstatus = 'captured';
            vm.save(false);
          }

          function formDisabled(scan) {
            let answer = true;
            if (angular.isObject(scan) && scan.hasOwnProperty('doccat') && scan.doccat === 'patient' && (angular.isString(scan.patientid) || angular.isString(scan.clientid))) {
              answer = false;
            }
            if (angular.isObject(scan) && scan.hasOwnProperty('doccat') && scan.doccat === 'generic') {
              answer = false;
            }
            return answer;
          }

          function formSignoffDisabled(scan) {
            let answer = true;

            if (angular.isObject(scan) && scan.hasOwnProperty('signature') && angular.isString(scan.signature) && scan.signature.length > 0) {
              answer = false;
            }
            return answer;
          }

          function save(lfinish) {
            if (!lfinish) {
              lfinish = false;
            }
            $log.debug('[DMS][SCAN][ScanSorter] save called for file._id, fileid, finish: ', vm.file._id, vm.file.fileid, lfinish);
            vm.parentsave({file: vm.file, finish: lfinish});
          }

          function parentRendered(file, success) {
            $log.debug('[DMS][SCAN][ScanSorter] rendered file success: ', vm.file._id, success);
            vm.parentrendered({file: vm.file, success: success});
          }


          function addLog() {
            if (vm.clientmode === 'patient') {
              LogReminderHelper.addLog(vm.file.patientid, vm.clientmode);
            } else {
              LogReminderHelper.addLog(vm.file.clientid, vm.clientmode);
            }
          }

          function addReminder() {
            if (vm.clientmode === 'patient') {
              LogReminderHelper.addReminder(vm.file.patientid, vm.clientmode);
            } else {
              LogReminderHelper.addReminder(vm.file.clientid, vm.clientmode);
            }
          }


          // PDF Viewer Function wrappers
          function previousPage() {
            pdfDelegate.$getByHandle('scans-pdf-container').prev();
            vm.currentpage = pdfDelegate.$getByHandle('scans-pdf-container').getCurrentPage();
          }

          function nextPage() {
            pdfDelegate.$getByHandle('scans-pdf-container').next();
            vm.currentpage = pdfDelegate.$getByHandle('scans-pdf-container').getCurrentPage();
          }

          function zoomIn() {
            pdfDelegate.$getByHandle('scans-pdf-container').zoomIn();
          }

          function zoomOut() {
            pdfDelegate.$getByHandle('scans-pdf-container').zoomOut();
          }

          function rotatePage() {
            pdfDelegate.$getByHandle('scans-pdf-container').rotate();
            vm.rotatestate = (vm.rotatestate + 1) % 4;
            vm.landscape = vm.rotatestate === 1 || vm.rotatestate === 3;
            $log.debug('[DMS][SCAN][ScanSorter] rotating, now at position: ', vm.rotatestate);
            $log.debug('[DMS][SCAN][ScanSorter] landscape view: ', vm.landscape);
          }

          function gotoPage() {
            if (vm.currentpage > 0 && vm.currentpage <= vm.maxpc) {
              pdfDelegate.$getByHandle('scans-pdf-container').goToPage(vm.currentpage);
            }
          }

        }

      ] // controller
    }); // component

// klammerfriedhof
}());
